import React, {Component} from 'react';
import {Form, FormLayout, TextField, Button} from "@shopify/polaris";
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider, Card} from '@shopify/polaris';
import './forgotPassword.css'
import {reqSendResetPasswordEmail} from "../../api/index";
import memory from '../../utils/memory';
import { Redirect } from 'react-router-dom';
import logo from '../../assets/logo.png'

export default class Forgotpassword extends Component{
    
    constructor(props) {
        super(props);
        this.state = {
            email:'',
            loading:false,
        };
      }

    //async 和await
    handleSubmit = (event) => {
        if(this.state.email === '')
        {
            alert('Please input your email.');
            return false;
        }

        this.setState({loading:true});

        reqSendResetPasswordEmail(this.state.email).then(
            response => {
                this.setState({loading:false});
                alert(response.data.message);
                
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    }

    render () {
        if(memory.user_info !== '{}')
        {
            return <Redirect to="/" />
        }

        return (
            <div className="forgot-passowrd">
                <AppProvider i18n={enTranslations}>
                    <Card sectioned>
                        <img className="logo" src={logo} alt='' />
                        <h1>Forgot password?</h1>
                        <h2>Enter your email address to recover password</h2>
                        <Form onSubmit={this.handleSubmit}>
                            <FormLayout>
                                <TextField
                                value={this.state.email}
                                label="Email"
                                type="email"
                                onChange={val => this.setState({email: val})}
                                />
                                
                                <Button loading={this.state.loading} primary submit>Send email</Button>
                            </FormLayout>
                        </Form>
                        <p onClick={() => this.props.history.replace('/login')}>
                            Return to login
                        </p>
                    </Card>
                </AppProvider>
            </div>
        )
    }
}
